import {Module} from 'vuex';
import {MemberAlertLocation} from './MemberAlertLocation';
import {loadMemberAlertLocations} from './MemberAlertServices';

interface MemberAlertStoreState {
    potentialLocations: MemberAlertLocation[];
}

export default {
    namespaced: true,
    state: {
        /* Represents the potential locations a member alert can be displayed at. This is synchronized with the database to ensure new ones don't need to be programmed into the application. */
        potentialLocations: []
    },
    getters: {
    },
    actions: {
        async load({ state, commit }) {
            if(state.potentialLocations.length > 0){
                return;
            }
            const locations = await loadMemberAlertLocations();
            commit('setPotentialLocations', locations);
        }
    },
    mutations: {
        setPotentialLocations(state, locations: MemberAlertLocation[]) {
            state.potentialLocations = locations;
        }
    },
} as Module<MemberAlertStoreState, any>;
